/**
 * Общее для мини-игр этапов жизни (G1–G7): это не азарт — тяга 0,
 * денег обычно нет, текст ожидания не показывается. Все жребии — из `Rng`.
 */
import { FLAG_YOUNGEST_AGE, type Life } from '@life/engine';

/** Исход без денег и тяги. */
export function nothing(): { moneyDelta: number; urgeDelta: number } {
  return { moneyDelta: 0, urgeDelta: 0 };
}

/**
 * Возраст младшего ребёнка: типизированное `childrenAges` (H1), иначе
 * `flags.youngestAge` (ведёт тик; старые сохранения), иначе null без детей.
 * Одна функция для мини-игр (`talk`, `night`) и мест (`home.child`).
 */
export function youngestAgeOf(life: Life): number | null {
  const typed = (Array.isArray(life.childrenAges) ? life.childrenAges : []).filter((a) => Number.isFinite(a) && a >= 0);
  if (typed.length > 0) return Math.min(...typed);
  const raw = life.flags[FLAG_YOUNGEST_AGE];
  return typeof raw === 'number' && Number.isFinite(raw) && raw >= 0 ? raw : null;
}

/** Числовой флаг или 0. */
export function numberFlag(life: Life, key: string): number {
  const raw = life.flags[key];
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : 0;
}

/** Сколько ударов `beats` получили свой тап в окне ±`window` мс (каждый тап засчитывается один раз). */
export function beatHits(beats: readonly number[], window: number, taps: readonly number[]): number {
  const free = (Array.isArray(taps) ? taps : []).filter((t) => typeof t === 'number' && Number.isFinite(t)).sort((a, b) => a - b);
  let hit = 0;
  for (const beat of beats) {
    const i = free.findIndex((t) => Math.abs(t - beat) <= window);
    if (i >= 0) {
      hit += 1;
      free.splice(i, 1);
    }
  }
  return hit;
}

/** Целые индексы из [0, n) без повторов, в порядке ввода. */
export function distinctIndexes(input: unknown, n: number): number[] {
  const out: number[] = [];
  for (const x of Array.isArray(input) ? input : []) {
    if (Number.isInteger(x) && x >= 0 && x < n && !out.includes(x)) out.push(x);
  }
  return out;
}
